enum FreezeForecast {
  FREEZE_FORECAST = 'billing-periods/freeze-forecast'
}

export default FreezeForecast;
